var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashCan = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 20 26",
  className: "_dm-svg",
  focusable: "false",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14 4h5.5c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5H.5a.502.502 0 01-.5-.5v-1c0-.275.225-.5.5-.5H6V2c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2zM8 4h4V2H8v2zM1.5 7h16.794c.39 0 .706.09.706.413V25.5c0 .324-.316.5-.706.5H1.5c-.39 0-.5-.326-.5-.326V7.5c0-.324.11-.5.5-.5zm4 16a.5.5 0 00.5-.5v-12a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h1zm5 0c.275 0 .5-.225.5-.5v-12c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5v12c0 .275.225.5.5.5h1zm5 0a.5.5 0 00.5-.5v-12a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h1z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashCan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TrashCan.56fe0adee2e5d5ba5181e7842a507093.svg";